import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Routing from "./Routing";

function App() {
  return (
    <div>
      <Navbar />
      <Routing />
      <Footer />
    </div>
  );
}

export default App;
